import { UnderlyingCodeTypeContext } from 'contexts/underlyingCodeTypeContext';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { useContext } from 'react';

export function useUnderlyingCodeType() {
  return useContext<UnderlyingCodeType>(UnderlyingCodeTypeContext);
}
